import { useState } from "react";
import Modal from "../ui/Modal";
import EditableText from "../ui/EditableText";

export default function FeeScheduleSection({
  title = "FEE SCHEDULE",
  description,
  editable = false,
  onSaveTitle,
  onSaveDescription,
}: {
  title?: string;
  description?: string;
  editable?: boolean;
  onSaveTitle?: (value: string) => void;
  onSaveDescription?: (value: string) => void;
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <section className="bg-white px-4 pb-16 pt-16 md:px-8">
      <div className="mx-auto max-w-6xl">
        <div className="mx-auto w-11/12 border-t border-dantzBlue" />

        <div className="mx-auto max-w-3xl text-center">
          <EditableText
            as="h2"
            value={title}
            editMode={editable}
            onSave={(value) => onSaveTitle?.(value)}
            className="my-12 block text-[28px] font-light tracking-widest text-dantzBlue"
          />

          {description && (
            <EditableText
              as="p"
              value={description}
              editMode={editable}
              multiline
              onSave={(value) => onSaveDescription?.(value)}
              className="mb-10 text-sm font-light leading-relaxed text-gray-600"
            />
          )}

          <button aria-label="Calculate your fees" onClick={() => setIsModalOpen(true)}>
            <img src="/images/btn-calculate-here.svg" alt="Calculate your fees" className="mx-auto" />
          </button>
        </div>
      </div>

      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title="Fee Schedule"
      >
        <p>Content coming soon.</p>
      </Modal>
    </section>
  );
}
